import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";

const defaultBackground = "paper";
const backgroundClassNames = {
  "blue-paper": "kaaj-background-blue-paper",
  "blue-rose-aura": "kaaj-background-blue-rose-aura",
  "cool-paper": "bg-surface-200",
  "dossier-grid": "kaaj-background-dossier-grid",
  "lavender-paper": "bg-surface-300",
  "lavender-rose-aura": "kaaj-background-lavender-rose-aura",
  "mint-paper": "kaaj-background-mint-paper",
  paper: "bg-background",
} as const;
const getBackgroundClassName = (background?: string) =>
  background
    ? backgroundClassNames[background as keyof typeof backgroundClassNames]
    : backgroundClassNames[defaultBackground];

export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) return null;
  return (
    <div
      className={cn(
        "kaaj-background-scope text-foreground",
        getBackgroundClassName(background),
        parentClass,
      )}
      data-background={background || defaultBackground}
      data-background-container=""
    >
      {components}
    </div>
  );
};
BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
